import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import OnVisible from 'react-on-visible';
import FeaturedCase01Component from '../featuredCase/featuredCase01.component';
import FeaturedCase02Component from '../featuredCase/featuredCase02.component';
import FeaturedCase03Component from '../featuredCase/featuredCase03.component';
import FeaturedCase04Component from '../featuredCase/featuredCase04.component';
import FeaturedCase05Component from '../featuredCase/featuredCase05.component';
import FeaturedCase06Component from '../featuredCase/featuredCase06.component';

class FeaturedPageComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.navigateToCase = this.navigateToCase.bind(this);
  }

  navigateToCase(event, slug) {
    event.preventDefault();

    /*MethodsService.getMethod('navigateWithTransition')(
        'toCase',
        <TeaserImage>
            <Image {...image} />
        </TeaserImage>,
        this.box.getBoundingClientRect(),
        `/work/${slug}/`
    );*/
  }
  renderCaseLayout() {
    let teaserImageWide = '';
    let module = this.props.page.hero.filter(el => {
      return el.__typename == 'DatoCmsHeroImage';
    });
    if (module.length) {
      teaserImageWide = module[0].image;
    }
    const attr = {
      teaserTitle: this.props.title,
      teaserImageWide: teaserImageWide,
      client: this.props.subtitle,
      slug: this.props.page.slug,
      hover: true,
      translateX: this.props.translateX,
    };
    if (this.props.layout == 1) {
      return <FeaturedCase01Component {...attr} />;
    }
    if (this.props.layout == 2) {
      return <FeaturedCase02Component {...attr} />;
    }
    if (this.props.layout == 3) {
      return <FeaturedCase03Component {...attr} />;
    }
    if (this.props.layout == 4) {
      return <FeaturedCase04Component {...attr} />;
    }
    if (this.props.layout == 5) {
      return <FeaturedCase05Component {...attr} />;
    }
    if (this.props.layout == 6) {
      return <FeaturedCase06Component {...attr} />;
    }
  }
  render() {
    // 1,2,1,3,1,2,4,1,5,6
    return (
      <FeatureCaseWrapper percent={30} id="FeaturedPageComponent">
        {/* <Link
                        to={`/work/${slug}/`}
                        onClick={event => this.navigateToCase(event, slug)}> */}
        {this.renderCaseLayout()}
        {/* </Link> */}
      </FeatureCaseWrapper>
    );
  }
}

const FeatureCaseWrapper = styled(OnVisible)`
background-color: #fff;`;

export default FeaturedPageComponent;
